module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-box stage-comment-box",
    class: {
      'active': true || _vm.open
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textarea),
      expression: "textarea"
    }],
    ref: "textArea",
    staticClass: "enter",
    attrs: {
      "placeholder": "输入反馈内容..."
    },
    domProps: {
      "value": (_vm.textarea)
    },
    on: {
      "keyup": _vm.mention,
      "focus": _vm.openBox,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textarea = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mentionList.length),
      expression: "mentionList.length"
    }],
    staticClass: "mention-result"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._l((_vm.mentionList), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "me-item",
      class: {
        actived: _vm.Mcurrent === index
      },
      on: {
        "click": function($event) {
          _vm.selectMention(item)
        },
        "mouseover": function($event) {
          _vm.changeCurrent(index)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.value))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "opt-item"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "hidden": _vm.images.length === 0,
      "value": _vm.images.length
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom-start",
      "title": "上传图片",
      "width": "400",
      "trigger": "click"
    }
  }, [_c('el-upload', {
    ref: "uploadImg",
    staticClass: "img-box",
    attrs: {
      "action": _vm.uploadUlr,
      "data": _vm.uploadData,
      "list-type": "picture-card",
      "accept": _vm.imgAccept,
      "on-remove": _vm.imgRemove,
      "on-error": _vm.handleError,
      "on-success": _vm.imgAdd,
      "file-list": _vm.uploadImg,
      "limit": 9,
      "before-upload": _vm.handleBeforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    on: {
      "click": _vm.set_upload_param
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "text web-icon-img",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })], 1)], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "opt-item"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "hidden": _vm.fileAttrValue.length === 0,
      "value": _vm.fileAttrValue.length
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom-start",
      "title": "上传附件",
      "width": "400",
      "trigger": "click"
    }
  }, [_c('el-upload', {
    ref: "uploadFile",
    attrs: {
      "action": _vm.uploadUlr,
      "data": _vm.uploadData,
      "on-remove": _vm.fileRemove,
      "on-success": _vm.fileAdd,
      "on-error": _vm.handleError,
      "before-upload": _vm.handleBeforeUpload,
      "file-list": _vm.uploadFile
    }
  }, [_c('el-button', {
    staticClass: "text",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.set_upload_param
    }
  }, [_vm._v("添加附件")])], 1), _vm._v(" "), _c('i', {
    staticClass: "text web-icon-file",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-button', {
    staticClass: "submit",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleEmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.closeBox
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("选择你要@的人")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93064e9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/comment-box/stage-comment-box.vue
// module id = 1319
// module chunks = 82